import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CONFIRM_PUBLIC_SUBSCRIPTIONS } from "../../constants";

const ConfirmPublicSubscriptions = () => {
    const { email, group_id } = useParams();

    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        handleConfirmation();
    });

    const handleConfirmation = () => {
        axios
            .post(
                `${CONFIRM_PUBLIC_SUBSCRIPTIONS}?email=${email}&group_id=${group_id}`
            )
            .then((response) => {
                if (response.status === 200) {
                    setSuccess("Public Subscription confirmed successfully");
                } else {
                    setError("Public Subscription confirmation unsuccessfull");
                }
            })
            .catch((error) => {
                if (error.response) {
                    setError("Public Subscription confirmation unsuccessfull");
                }
            });
    };

    return (
        <div>
            <h1>Confirmed</h1>
            <div>
                Email: {email}
                Group_id: {group_id}
            </div>
            {success ? success : null}
            {error ? error : null}
        </div>
    );
};

export default ConfirmPublicSubscriptions;
